import { Api } from "../Api/Api";

export const getUserListApi = () => Api.get("api/GetUsersList");

export const getUserProfile = (user_id) => Api.get(`api/GetUsersList?user_id=${user_id}`);

export const getGroupProfile = ()=> Api.get("api/getGroupDetail")
